import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-admin',
  styleUrls: ['./admin.component.scss'],
  templateUrl: './admin.component.html',
})
export class AdminComponent implements OnInit {
  menus: MenuItem[] = [
    {
      label: `${environment.names.bef} Staging (SSO)`,
      icon: 'pi ihg153',
      command: () => {
        window.open('https://ls-stg.ihg-wo.com/login?enableSSO=true', '_blank');
      },
    },
    {
      label: `${environment.names.scheduler} Staging (SSO)`,
      icon: 'pi ihg11',
      command: () => {
        window.open('https://tp-stg.ihg-wo.com/login?enableSSO=true', '_blank');
      },
    },
    {
      label: `${environment.names.bef} Staging`,
      icon: 'pi ihg153',
      command: () => {
        window.open('https://ls-stg.ihg-wo.com/login?disableSSO=true', '_blank');
      },
    },
    {
      label: `${environment.names.scheduler} Staging`,
      icon: 'pi ihg11',
      command: () => {
        window.open('https://tp-stg.ihg-wo.com/login?disableSSO=true', '_blank');
      },
    },
    {
      label: 'Tableau Reporting',
      icon: 'pi ihg29',
      command: () => {
        window.open('https://tableau.ihg.com/#/site/Departmental/projects/990', '_blank');
      },
    },
    {
      label: 'UKG EU IMEA UAT',
      icon: 'pi ihg4',
      styleClass: 'ukg-eu',
      command: () => {
        window.open('https://ihghotels-uat-sso.npr.mykronos.com', '_blank');
      },
    },
    {
      label: 'UKG EU IMEA DATAHUB',
      icon: 'pi ihg146',
      styleClass: 'ukg-eu',
      command: () => {
        window.open('https://ihghotels-dhub-sso.prd.mykronos.com/datahub/selfservice/components/home', '_blank');
      },
    },
    {
      label: 'UKG EU IMEA DEV',
      icon: 'pi ihg4',
      styleClass: 'ukg-eu',
      command: () => {
        window.open('https://ihghotels-dev.npr.mykronos.com', '_blank');
      },
    },
    {
      label: 'UKG SEAK JAPAC UAT',
      icon: 'pi ihg4',
      styleClass: 'ukg-japac',
      command: () => {
        window.open('https://ihghotels2-uat-sso.npr.mykronos.com', '_blank');
      },
    },
    {
      label: 'UKG SEAK JAPAC DATAHUB',
      icon: 'pi ihg146',
      styleClass: 'ukg-japac',
      command: () => {
        window.open('https://ihghotels2-dhub-sso.prd.mykronos.com/datahub/selfservice/components/home', '_blank');
      },
    },
    {
      label: 'UKG SEAK JAPAC DEV',
      icon: 'pi ihg4',
      styleClass: 'ukg-japac',
      command: () => {
        window.open('https://ihghotels2-dev.npr.mykronos.com', '_blank');
      },
    },
    {
      label: 'UKG AMER DEV',
      icon: 'pi ihg4',
      styleClass: 'ukg-amer',
      command: () => {
        window.open('https://ihghotelsamer.prd.mykronos.com/', '_blank');
      },
    },
    {
      label: 'UKG Community Support',
      icon: 'pi ihg196',
      styleClass: 'support',
      command: () => {
        window.open('https://community.ukg.com/s/contactsupport', '_blank');
      },
    },
    {
      label: 'Service Now Support Tickets',
      icon: 'pi ihg196',
      styleClass: 'support',
      command: () => {
        window.open('https://ihg.service-now.com/nav_to.do?uri=%2Fhome.do%3F', '_blank');
      },
    },
    {
      label: 'Azure Devops',
      icon: 'pi ihg160',
      styleClass: 'support',
      command: () => {
        window.open('https://sudoorgza.visualstudio.com/IHG%20WOT/_boards/board/t/IHG%20WOT%20Team/Issues', '_blank');
      },
    },
  ];

  adminMenus = [
    {
      label: 'WO Applications',
      icon: 'pi ihg10',
      routerLink: ['/home'],
    },
    {
      label: `${environment.names.bef} Maintenance Login`,
      icon: 'pi ihg12',
      command: () => {
        window.open(`https://ls.ihg-wo.com/maintenance/login/${Date.now()}`, '_blank');
      },
    },
  ];

  homeMenu = {
    label: 'Workforce Optimisation Applications',
    icon: 'pi ihg10',
    routerLink: ['/home'],
  };

  maintMenu = {
    label: `${environment.names.bef} Maintenance Login`,
    icon: 'pi ihg12',
    command: () => {
      // we add a uniqueish string to the end to try to help with caching issues
      window.open(`https://ls.ihg-wo.com/maintenance/login/${Date.now()}`, '_blank');
    },
  };

  constructor() {}

  ngOnInit() {}
}
